/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAddCustomIpAddressesRequest
 */
export interface ControlAddCustomIpAddressesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAddCustomIpAddressesRequest
     */
    ip_addresses: Array<string>;
}

/**
 * Check if a given object implements the ControlAddCustomIpAddressesRequest interface.
 */
export function instanceOfControlAddCustomIpAddressesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ip_addresses" in value;

    return isInstance;
}

export function ControlAddCustomIpAddressesRequestFromJSON(json: any): ControlAddCustomIpAddressesRequest {
    return ControlAddCustomIpAddressesRequestFromJSONTyped(json, false);
}

export function ControlAddCustomIpAddressesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAddCustomIpAddressesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ip_addresses': json['ip_addresses'],
    };
}

export function ControlAddCustomIpAddressesRequestToJSON(value?: ControlAddCustomIpAddressesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ip_addresses': value.ip_addresses,
    };
}

